/**
 * Leep Chás — Image banner slideshow + controles
 */
(function () {
  var INIT_FLAG = 'imageBannerInit';

  function initBanner(banner) {
    if (!banner || banner.dataset[INIT_FLAG] === 'true') return;

    var slides = banner.querySelectorAll('[data-image-banner-slide]');
    if (slides.length < 2) return;

    banner.dataset[INIT_FLAG] = 'true';

    var duration = parseInt(banner.dataset.slideDuration, 10) || 5000;
    var current = 0;
    var timer = null;
    var dots = banner.querySelectorAll('[data-image-banner-dot]');

    function showSlide(index) {
      var nextIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === nextIndex);
      });
      dots.forEach(function (dot, i) {
        var active = i === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      current = nextIndex;
    }

    function nextSlide() {
      showSlide(current + 1);
    }

    function prevSlide() {
      showSlide(current - 1);
    }

    function start() {
      stop();
      timer = window.setInterval(nextSlide, duration);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function manualNavigate(fn) {
      stop();
      fn();
      start();
    }

    banner.addEventListener('click', function (event) {
      if (event.target.closest('[data-image-banner-prev]')) {
        event.preventDefault();
        event.stopPropagation();
        manualNavigate(prevSlide);
        return;
      }

      if (event.target.closest('[data-image-banner-next]')) {
        event.preventDefault();
        event.stopPropagation();
        manualNavigate(nextSlide);
        return;
      }

      var dot = event.target.closest('[data-image-banner-dot]');
      if (dot) {
        event.preventDefault();
        event.stopPropagation();
        var index = parseInt(dot.dataset.slideIndex, 10);
        if (!Number.isNaN(index)) {
          manualNavigate(function () {
            showSlide(index);
          });
        }
      }
    });

    banner.addEventListener('mouseenter', stop);
    banner.addEventListener('mouseleave', start);
    banner.addEventListener('touchstart', stop, { passive: true });
    banner.addEventListener('touchend', function () {
      window.setTimeout(start, 3000);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-image-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
